/* eslint-disable @typescript-eslint/no-explicit-any */
// twilioCallingSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface CallStates {
  callingLeadId: string;
  callingNumber: string;
  isCalling: boolean;
  isMuted: boolean;
  callStatus: string;
  device: any;
  activeConnection: any;
  callDuration: number;
  timerInterval: ReturnType<typeof setInterval> | null;
  redirectTo: string;
}

export interface TwilioCallingState {
  callStates: CallStates;
  searchValue: string;
  minimizeCall: boolean;
}

const initialState: TwilioCallingState = {
  callStates: {
    callingLeadId: "",
    callingNumber: "",
    isCalling: false,
    isMuted: false,
    callStatus: "",
    device: {},
    activeConnection: {},
    callDuration: 0,
    timerInterval: null,
    redirectTo: "",
  },
  searchValue: "",
  minimizeCall: false,
};

export const twilioCallingSlice = createSlice({
  name: "twilioCalling",
  initialState,
  reducers: {
    setCallStates(state, action: PayloadAction<Partial<CallStates>>) {
      state.callStates = { ...state.callStates, ...action.payload };
    },
    setSearchValue(state, action: PayloadAction<string>) {
      state.searchValue = action.payload;
    },
    setMinimizeCall(state, action: PayloadAction<boolean>) {
      state.minimizeCall = action.payload;
    },
  },
});

export const { setCallStates, setSearchValue, setMinimizeCall } =
  twilioCallingSlice.actions;
